import { addDays, eachDayOfInterval, endOfMonth, endOfWeek, startOfMonth, startOfWeek } from 'date-fns';
import { toZonedTime } from 'date-fns-tz';
import { useMemo } from 'react';
import type { CalendarMode, WeekStartsOn } from '../types';

export const useGetDays = ({
  date,
  mode,
  timezone,
  weekStartsOn = 1,
}: {
  date: Date;
  mode: CalendarMode;
  timezone: string;
  weekStartsOn?: WeekStartsOn;
}) =>
  useMemo(() => {
    const zonedDate = toZonedTime(date, timezone);

    switch (mode) {
      case 'day':
        return [zonedDate];
      case 'month': {
        const intervalStart = startOfWeek(startOfMonth(zonedDate), { weekStartsOn });
        const intervalEnd = endOfWeek(endOfMonth(zonedDate), { weekStartsOn });
        return eachDayOfInterval({ end: intervalEnd, start: intervalStart });
      }
      case 'week': {
        const weekStart = startOfWeek(zonedDate, { weekStartsOn });
        return Array.from({ length: 7 }, (_, index) => addDays(weekStart, index));
      }
    }
  }, [date, mode, timezone, weekStartsOn]);
